import { Skeleton } from 'antd';
import React from 'react';

export const RmmSkeleton = () => {
  return (
    <div className="space-y-3">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="bg-white dark:bg-slate-800/60 rounded-xl border border-slate-100 dark:border-slate-700/60 px-4 py-3.5"
        >
          <Skeleton active title={{ width: '40%' }} paragraph={{ rows: 3 }} />
        </div>
      ))}
    </div>
  );
};
